import { rand, randNumber, randRecentDate, randFullName, randWord, randFutureDate } from '@ngneat/falso';

import { Activity, ItemTypes, ItemActivities, ItemActions } from './activity';

export class MockActivity extends Activity {
   constructor() {
      super({
         id: randNumber(),
         timestamp: randRecentDate().toISOString(),
         userFullName: randFullName(),
         name: randWord(),
         pkey: randWord(),
         actionExpiration: randFutureDate().toISOString(),
         type: rand( ItemTypes.slice( 1 )),
         activity: rand( ItemActivities.slice( 1 )),
         actions: ItemActions,
         isLast: false,
      });
   }
}
